export const projectList = [
    { name: 'The Ghost of Lake', path: '/projects/the-ghost-of-lake' },
    // { name: 'Herdling', path: '/projects/herdling' },
    // { name: 'Far Lone Sails', path: '/projects/far-lone-sails' },
];
